import React from "react";
import { PhaseDto } from "../../../../../dtos/PhaseDto";
import { cycleVocabulary, cyclesNewestFirst } from "../taskCycle";

export interface ITaskCycleIndicatorProps {
    phase?: PhaseDto | null;
    // The cycle being viewed; null means the latest (active) one.
    selectedSubmissionId: string | null;
}

// Names the cycle the open subtask belongs to. The subtask column groups every cycle, so once a
// subtask is open this keeps it clear which submission it came from.
export function TaskCycleIndicator({ phase, selectedSubmissionId }: ITaskCycleIndicatorProps) {
    const cycles = cyclesNewestFirst(phase);

    // A task that has only ever had one cycle has nothing to disambiguate.
    if (cycles.length < 2) return null;

    const active = cycles.find(c => c.id === (selectedSubmissionId ?? cycles[0].id)) ?? cycles[0];
    const vocabulary = cycleVocabulary;

    return (
        <span
            data-testid="task-cycle-indicator"
            style={{ display: "inline-flex", alignItems: "center", gap: "6px", whiteSpace: "nowrap" }}
        >
            <i className="dx-icon-folder" aria-hidden="true" />
            <span>{vocabulary.viewingLabel(active.resubmission ?? 0)}</span>
        </span>
    );
}
